import CollapsibleItem from './collapsible';
export default () => {
  if (!document.getElementsByClassName('layout-footer__collapsible-nav')) {
    return false;
  }
  new CollapsibleItem('.layout-footer__collapsible-nav');
};
